import { observer } from "mobx-react-lite";
import Media from "../../api/Media";
import { resolveManagersForSubscriptionItem } from "../../utils/reportManagerFilterUtils";

export const ItemAllReport = observer((props) => {
  const getActiveDate = () => {
    if (props.lic.validity_date === null) {
      return "Не приобреталась";
    }
    const dt = new Date().getTime();
    const dt2 = new Date(props.lic.validity_date).getTime();
    if (dt2 - dt < 0) {
      return "Истекла";
    }
    return Math.ceil((dt2 - dt) / (1000 * 60 * 60 * 24));
  };

  const companyName = props.lic.company_rel.name_company;
  const displayName =
    !Media.mobile || companyName.length <= 16
      ? companyName
      : `${companyName.slice(0, 16)}...`;

  const { responsible, support } = resolveManagersForSubscriptionItem(
    props.lic,
    props.companys,
  );

  return (
    <div
      className={`cc-v4-soft-row ${props.gridClass} reports-soft-row`}
      onClick={() => props.toCompany(props.lic)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          props.toCompany(props.lic);
        }
      }}
    >
      <span className="reports-cell">{displayName}</span>
      <span className="reports-cell company-card-v4-mono">
        {props.lic.company_rel.inn}
      </span>
      <span
        className={`reports-cell${
          responsible.muted ? " reports-cell-muted" : ""
        }`}
      >
        {responsible.text}
      </span>
      <span
        className={`reports-cell${support.muted ? " reports-cell-muted" : ""}`}
      >
        {support.text}
      </span>
      <span className="reports-cell reports-cell-numeric">{getActiveDate()}</span>
      <span className="reports-cell reports-cell-numeric">
        {props.lic.validity_date}
      </span>
    </div>
  );
});
